import { mapDTO } from '@twistezo/ts-dto-mapper'

import { parseValidJSON } from 'utils/json'
import { EditPaapiSchema, WorkspaceBidder } from '../../../schemas/editPaapiSchema'
import { Variables } from './types'

type From = EditPaapiSchema
type To = Variables

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      bidders,
      componentSeller,
      defaultForSlots,
      enabled,
      id,
      meta: { workspaceBidders },
      paapiForGpt,
      parallel,
    } = data

    return {
      enabled,
      id,
      params: {
        componentSeller: parseValidJSON(
          componentSeller.length > 0 ? componentSeller : '{}',
        ) as JSON,
        defaultForSlots,
        paapiForGpt,
        parallel,
      },
      workspaceBidderIds: mapBidderCodesToIds(bidders, workspaceBidders),
    }
  })

const mapBidderCodesToIds = (
  bidderCodes: WorkspaceBidder['bidderCode'][],
  metaWorkspaceBidders: WorkspaceBidder[],
): WorkspaceBidder['id'][] =>
  bidderCodes.map((bidderCode: WorkspaceBidder['bidderCode']): WorkspaceBidder['id'] => {
    const metaWorkspaceBidder: undefined | WorkspaceBidder = metaWorkspaceBidders.find(
      (workspaceBidder: WorkspaceBidder): boolean => workspaceBidder.bidderCode === bidderCode,
    )
    if (metaWorkspaceBidder === undefined) {
      throw Error('Related meta Workspace Bidder should exists.')
    }

    return metaWorkspaceBidder.id
  })
